module.exports = __webpack_public_path__ + "img/aula_chikung.b7b8b45c.jpeg";